var $toggleAccordion;

$(document).ready(function($) {
    $toggleAccordion    = $('.js-toggle-accordion');

    $toggleAccordion.on('click', function(e) {
        e.stopPropagation();
        let $parent = $(this).parent();

        if ($parent.hasClass('is-open')) {
            $parent.removeClass('is-open');
            $(this).next().stop().slideUp();

        } else {
            $toggleAccordion.parent().removeClass('is-open');
            $toggleAccordion.next().stop().slideUp();

            $parent.addClass('is-open');
            $(this).next().stop().slideDown();
        }
    });
});